/**
 * Client-safe URL utility functions
 * These functions can be used in client components without importing server-only code
 */

/**
 * Determines if a URL is relative or absolute.
 *
 * @param {*} url
 * @return {boolean}
 */
export function isRelativeURL(url) {
    try {
        new URL(url); // Attempt to create a URL object
        return false; // URL has an origin if this succeeds
    } catch (error) {
        return true; // URL is missing origin
    }
}

/**
 * Determines if a URL is internal (relative or from dotCMS domains).
 * Internal domains include: www.dotcms.com, dev.dotcms.com
 *
 * @param {string} url - The URL to check
 * @returns {boolean} - True if the URL is internal, false otherwise
 */
export function isInternalURL(url) {
    if (!url) {
        return false;
    }
    if (isRelativeURL(url)) {
        return true;
    }

    try {
        const urlObj = new URL(url);
        const hostname = urlObj.hostname.toLowerCase();

        return (
            hostname === 'www.dotcms.com' ||
            hostname === 'dev.dotcms.com' ||
            hostname === 'www.dev.dotcms.com' ||
            hostname === 'dotcms.com'
        );
    } catch (error) {
        return true;
    }
}
